import { Dispatch, SetStateAction } from "react"

import {
    Box,
    Text,
    Radio,
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItemOption,
    RadioGroup,
    Flex,
} from "@chakra-ui/react"
import { ChevronDownIcon } from "@chakra-ui/icons"

export interface Option {
    value: string,
    label: string
}

interface InputSelectRadioProps {
    setMaximumDateFilter: Dispatch<SetStateAction<Option>>
    maximumDateFilter: Option
    options: Array<Option>
}

export const InputSelectRadio = ({
    setMaximumDateFilter,
    maximumDateFilter,
    options
}: InputSelectRadioProps) => {

    const handleOnChange = (value) => {
        const option = options.find((option) => option.value === value) || options[0]
        setMaximumDateFilter(option)
    }

    return (
        <Box>
            <Menu>
                <MenuButton
                    variant="secondary"
                    as={Button}
                    rightIcon={<ChevronDownIcon />}
                    borderColor={maximumDateFilter.value !== '0' ? "#2D64BC" : '#D8D8D8'}
                >
                    <Flex
                        alignItems="center"
                        gap="2"
                    >
                        <Text>Post Publish Date: <Text as="b">{maximumDateFilter.label}</Text></Text>
                    </Flex>
                </MenuButton>
                <MenuList>
                    <RadioGroup
                        onChange={handleOnChange}
                        value={maximumDateFilter.value}
                    >
                        <RenderOptions options={options} />
                    </RadioGroup>
                </MenuList>
            </Menu>
        </Box>
    )
}

const RenderOptions = ({ options }) => {
    return (
        <>
            {options.map((option) => (
                <MenuItemOption
                    key={option.value}
                    icon={<></>}
                >
                    <Radio
                        value={option.value}
                    >
                        {option.label}
                    </Radio>
                </MenuItemOption>
            ))}
        </>
    );
};